import {
    changeActiveWheels, changeCutType, changeIsRunflat,
    changeRadius,
    changeWheelDiskType, setCutType,
    setIsActive, setIsRunflat,
    setRadius,
    setWheelDiskType
} from "./constants";
import axios from "../../../plugins/axios-common";

export default {
    namespaced: true,
    state: {
        error: [false,false,false,false],
        optionsListLoading: true,
        isFirstTab: true,
        availableTire:[
            12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24
        ],
        typeSelected: 0,
        paintTypes: [],
        colors: [],
        varnishes: [],
        colorsT3: [
            { id: 1, name: 'Черный' },
            { id: 2, name: 'Белый' },
            { id: 3, name: 'Серебро' },
            { id: 4, name: 'Графит темный' },
        ],
        varnishesT3: [
            { id: 1, name: 'Матовый' },
            { id: 2, name: 'Глянцевый' },
        ],
        options: [],
        costumerDiscount: 12,
        url: '/calc/',
        QRcodeUrl: '/QR.png',
        wheels: {
            forwardLeft: {
                isActive: true,
                data: {},
            },
            forwardRight: {
                isActive: true,
                data: {},

            },
            backLeft: {
                isActive: true,
                data: {},

            },
            backRight: {
                isActive: true,
                data: {},
            },
            spareLeft: {
                isActive: false,
                data: {},
            },
            spareRight: {
                isActive: false,
                data: {},
            },
        },
    },
    mutations: {
        setIsFirstTab (state, value) {
            state.isFirstTab = value
        },
        addData (state, payload) {
            const {value, side} = payload;
            state.wheels[side].data = JSON.parse(JSON.stringify(value))
        },
        [setRadius](state, payload) {
            const {value, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.radius = value
                }
            } else{
                state.wheels[side].data.radius = value
            }
        },
        setRadiusRate(state, payload) {
            const {value, side} = payload;
            state.wheels[side].data.radiusRate = value
        },
        setError(state, [n,value] ) {
            state.error[n] = value
        },
        [setIsActive](state, payload) {
            const {value, side} = payload;
            state.wheels[side].isActive = value
        },
        [setWheelDiskType](state, payload) {
            const {value, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.solidDisk = value
                }
            } else{
                state.wheels[side].data.solidDisk = value
            }
        },
        [setIsRunflat](state, payload) {
            const {value, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.isRunflat = value
                }
            } else{
                state.wheels[side].data.isRunflat = value
            }
        },
        setColors (state, value) {
            state.colors = [...value]
        },
        setVarnishes (state, value) {
            state.varnishes = [...value]
        },
        diskPaintType (state, payload) {
            const { index, side } = payload
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.paintTypes = index
                }
            } else {
                state.wheels[side].data.paintTypes = index
            }
        },
        setPaintTypes (state, value) {
            state.paintTypes = [...value]
        },
        setOptions (state, value) {
            state.options = JSON.parse(JSON.stringify(value))
        },
        addOptions (state, payload) {
            const {value, side} = payload
            state.wheels[side].data.options = JSON.parse(JSON.stringify(value))
        },
        updateOptions (state, payload) {
            const {value, side, id} = payload
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.options[id] = value
                }
            } else{
                state.wheels[side].data.options[id] = value
            }

        },
        changeQuantity (state, payload) {
            const {value, side, id } = payload
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data.optionsQ[id] = value
                }
            } else{
                state.wheels[side].data.optionsQ[id] = value
            }

        },
        setPlus (state, payload) {
            const {value, item, side} = payload;
            if(state.isFirstTab){
                for (let x in state.wheels){
                    state.wheels[x].data[item] = value                }
            } else {
                state.wheels[side].data[item] = value
            }
        },
        setPlusToZero (state) {
            for (let x in state.wheels){
                for (let y in state.wheels[x].data.options){
                    state.wheels[x].data.options[y] = false
                }
            }
        },
        setOptionsListLoading (state, value) {
            state.optionsListLoading = value
        },
    },
    actions: {
        async init({ rootState, getters, commit, state }) {
            let options = {}
            let optionsQ = {}
            for (let key of Object.entries(state.options)) {
                options[key[0]] = false
                optionsQ[key[0]] = 1
            }
            let data = {
                radius: parseInt(rootState.clientCard.diskSize.replace('R','')),
                radiusRate: 0,
                solidDisk: rootState.clientCard.diskType!=="shtamp",
                isRunflat: rootState.clientCard.runflat,
                paintTypes: 0,
                twoColors: false,
                firstColor: null,
                firstVarnish: null,
                secondColor: null,
                secondVarnish: null,
                options: options,
                optionsQ: optionsQ,
            }
            getters.sides.forEach(side => {
                console.log('side')
                commit('addData', {side: side.sideName, value:data})
            });
        },
        diskPaintPrice ({ commit, dispatch, state }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: 'get',
                    url: 'calc/disc-paint.json',
                })
                    .then((response) => {
                        commit('setPaintTypes', response.data.types)
                        commit('setColors', response.data.colors)
                        commit('setVarnishes', response.data.varnishes)
                        if(state.options.length === 0){
                            dispatch('setOptions', response.data.additionals)
                        }
                        resolve(response.data)
                    }).catch((e) => {
                    reject(e)
                })
            })
        },
        setOptions ({ commit }, value) {
            let tempWheelOptions = {}
            let tempOptions = {}
            value.forEach((x) => {
                tempOptions[x.id] = x
                tempWheelOptions[x.id] = false
            })
            commit('setOptions', tempOptions)
            commit('setOptionsListLoading', false)
        },
        setRadius({state, commit}, payload) {
            console.log('pl', payload)
            const { value, side } = payload;
            commit(setRadius, payload)
            if(value > 12){
                for (let x in state.extraDiameters) {
                    if (state.extraDiameters[x].radius === value) {
                        commit('setRadiusRate', { side, value: state.extraDiameters[x].price})
                    }
                }
            }
        },
        [changeActiveWheels]({commit}, [payload, canChange]) {
            for (const side in payload) {
                if(canChange) commit(setIsActive, {side, value: payload[side]})
            }
        },
        [changeRadius]({state, commit}, payload) {
            const {side, value} = payload;
            const options = state.wheels[side].data.radius.map(option => {
                if (option.value === value) {
                    return {...option, selected: true}
                } else {
                    return {...option, selected: false}
                }
            });
            commit(setRadius, {side, value: options})
        },
        [changeWheelDiskType]({commit}, payload) {
            commit(setWheelDiskType, payload)
        },
        [changeIsRunflat]({commit}, payload) {
            commit(setIsRunflat, payload)
        },
        [changeCutType]({commit}, payload) {
            commit(setCutType, payload)
        },
    },

    getters: {
        sides: state => [
            {...state.wheels.forwardLeft, sideName: 'forwardLeft'},
            {...state.wheels.forwardRight, sideName: 'forwardRight'},
            {...state.wheels.backLeft, sideName: 'backLeft'},
            {...state.wheels.backRight, sideName: 'backRight'},
            {...state.wheels.spareLeft, sideName: 'spareLeft'},
            {...state.wheels.spareRight, sideName: 'spareRight'},
        ],
    },
}
